export default "__VITE_ASSET__d85018cf__"